import React from 'react'
import cn from 'classnames'

import NumberPad from '../../components/NumberPad'
import SecureDots from './SecureDots'
import HamburgerMenu from './HamburgerMenu'
import NetworkIndicator from '../../containers/NetworkIndicator'
import Button from '../Button'
import Clock from '../Clock'
import Lock from '@material-ui/icons/Lock';

import { Oval } from  'react-loader-spinner'

import styles from './Component.module.scss'

const UserLoginComponent = ({ venueName, pin, pinSize, pinLoginStatus, pinLoginStatusText, handlePinEntry, handleSubmit, onOpenMenu }) => {
  const signInButton = <Button className={styles.signIn} onClick={() => handleSubmit(true)}>Sign In</Button>

  const mediaQuery = window.matchMedia("(min-width: 450px)")

  let content = (
    <>
      <h1>Enter Your Passcode</h1>
      <SecureDots count={pinSize} subjectSize={pin.length} />
      <NumberPad onTapButton={handlePinEntry} />
      {signInButton}
    </>
  )

  const isLoading = ['loading', 'succeeded'].includes(pinLoginStatus)

  if (isLoading) {
    content = (<div className={styles.loader}>
      <Oval
        height={262}
        width={262}
        color='#1463F5'
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel='oval-loading'
        secondaryColor='#000000'
        strokeWidth={2}
        strokeWidthSecondary={2}
      />
    </div>)
  }

  return (
    <div className={cn(styles.userLogin, { [styles.loading]: isLoading })}>
      { !isLoading && (
        <>
          <div className={styles.navbar}>
            <div className={styles.lockButton} onClick={onOpenMenu}>
              <Lock style={{ color: "white" }}/>
            </div>
            <div className={styles.vender}>
              <HamburgerMenu name={venueName} />
            </div>
            <div className={styles.contentRight}>
              <NetworkIndicator />
            </div>
          </div>
        </> 
      )}
      <div className={styles.pinForm}>
        {content}
      </div>
    </div>
  )
}
export default UserLoginComponent
